import React, { memo } from "react";
import cx from "classnames";
import propTypes from "prop-types";
import { noop } from "lodash";

import _get from "lodash/get";

import Icon from "../../icons";
import { Link, useLocation } from "react-router-dom";
import { ROUTES } from "../../../constants/routes.constants";

import styles from "./sideDrawerListItem.module.scss";

const SideDrawerListItem = ({ icon, title, route, disabled, onRestrictedClick }) => {
  const location = useLocation();
  const pathname = _get(location, "pathname", ROUTES.HOME);

  const handleClick = (e) => {
    if (disabled) {
      e.preventDefault();
      onRestrictedClick();
    }
  };

  return (
    <Link to={disabled ? "#" : route} onClick={handleClick}>
      <div
        className={cx(styles.dashboardMenuList, {
          [styles.active]:
            route !== "/" ? pathname.includes(route) : pathname === route,
          [styles.disabled]: disabled,
        })}
      >
        <Icon type={icon} />
        <p>{title}</p>
      </div>
    </Link>
  );
};

SideDrawerListItem.propTypes = {
  icon: propTypes.string,
  title: propTypes.string,
  hasStroke: propTypes.bool,
  route: propTypes.string,
  disabled: propTypes.bool,
  onRestrictedClick: propTypes.func,
};

SideDrawerListItem.defaultProps = {
  icon: "",
  title: "",
  hasStroke: true,
  route: ROUTES.HOME,
  disabled: false,
  onRestrictedClick: noop,
};

export default memo(SideDrawerListItem);
